export const types = {
	INIT_DOCUMENTS: "INIT_FORM_MT_DOCUMENTS",
	ADD_DOCUMENT: "ADD_FORM_MT_DOCUMENT",
	REMOVE_DOCUMENT: "REMOVE_FORM_MT_DOCUMENT",
	RESET_DOCUMENTS: "RESET_FORM_MT_DOCUMENTS",
}

export const initFormMTDocs = (documents) => {
	return (dispatch) => dispatch({
		type: types.INIT_DOCUMENTS,
		payload: documents
	})
}

export const addFormMTDoc = (docData) => {
	return (dispatch) => dispatch({
		type: types.ADD_DOCUMENT,
		payload: docData
	})
}

export const removeFormMTDoc = (docId) => {
	return (dispatch) => dispatch({
		type: types.REMOVE_DOCUMENT,
		payload: docId
	})
}

export const resetFormMTDocs = () => {
	return (dispatch) => dispatch({
		type: types.RESET_DOCUMENTS,
	})
}
